import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateWorkspace } from '@/entities/collab';
import type { Workspace } from '@/entities/workspace';
import { FormError } from '@/shared/forms';
import { Button, Dialog, DialogActions, TextField } from '@/shared/ui';

import styles from './CreateWorkspaceDialog.module.css';

/** Creates a team workspace; the creator becomes its only owner. */
export function CreateWorkspaceDialog({
  onCreated,
  onClose,
}: {
  onCreated: (workspace: Workspace) => void;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const create = useCreateWorkspace();
  const [name, setName] = useState('');
  return (
    <Dialog title={t('home.newWorkspace')} onClose={onClose}>
      <form
        className={styles.form}
        onSubmit={(event) => {
          event.preventDefault();
          const value = name.trim();
          if (!value) return;
          create.mutate({ name: value }, { onSuccess: onCreated });
        }}
      >
        <TextField
          label={t('home.workspaceName')}
          value={name}
          maxLength={100}
          autoFocus
          onChange={(event) => {
            setName(event.target.value);
          }}
        />
        <p className={styles.hint}>{t('home.workspaceHint')}</p>
        <FormError error={create.error} />
        <DialogActions>
          <Button type="button" variant="ghost" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button type="submit" variant="primary" disabled={create.isPending || !name.trim()}>
            {t('home.createWorkspace')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
